import React, { useState } from 'react';
import { useAuth } from '../auth';
import api from '../api';
import './estilodashuser.css';

const ResetSenhaUser = () => {
  const { user } = useAuth();
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [erro, setErro] = useState('');

  const handleResetSenha = async () => {
    if (!novaSenha || !confirmarSenha) {
      setErro('Todos os campos são obrigatórios.');
      setMensagem('');
      return;
    }

    if (novaSenha !== confirmarSenha) {
      setErro('As senhas não coincidem.');
      setMensagem('');
      return;
    }

    try {
      const response = await api.put(
        `/api/clientes/reset-senha/${user.id}`,
        { novaSenha }
      );

      setMensagem(response.data.message || 'Senha alterada com sucesso!');
      setErro('');
      setNovaSenha('');
      setConfirmarSenha('');
    } catch (error) {
      console.error('Erro ao resetar a senha:', error);
      setErro(
        error.response?.data?.message ||
          'Erro ao alterar a senha. Tente novamente.'
      );
      setMensagem('');
    }
  };

  return (
    <div className="reset-senha-container">
      <h2>Alterar Minha Senha</h2>
      <div className="reset-senha-form">
        <label htmlFor="novaSenha">Nova Senha:</label>
        <input
          type="password"
          id="novaSenha"
          value={novaSenha}
          onChange={(e) => setNovaSenha(e.target.value)}
          placeholder="Digite sua nova senha"
        />

        <label htmlFor="confirmarSenha">Confirmar Nova Senha:</label>
        <input
          type="password"
          id="confirmarSenha"
          value={confirmarSenha}
          onChange={(e) => setConfirmarSenha(e.target.value)}
          placeholder="Confirme sua nova senha"
        />

        <button onClick={handleResetSenha} className="btn-reset-senha">
          Alterar Senha
        </button>
      </div>

      {erro && <p className="error-message">{erro}</p>}
      {mensagem && <p className="success-message">{mensagem}</p>}
    </div>
  );
};

export default ResetSenhaUser;
